module.exports = __webpack_public_path__ + "media/fonts/Quicksand-SemiBold-d4f6bc51411626477b056f8d63edbd2f.ttf";